import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  removeDocumentById,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformCustomerWebhook } from './customer-webhooks.transformer';
import type { CustomerWebhooksCollection } from './customer-webhooks.types';

export function customerWebhooksReducer(
  state: CollectionStateSlice<CustomerWebhooksCollection> = {},
  action: CollectionActions<CustomerWebhooksCollection>,
): CollectionStateSlice<CustomerWebhooksCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'customerWebhooks') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<CustomerWebhooksCollection>(
          state,
          transformIntoDocuments(result.webhooks, transformCustomerWebhook),
          order,
          ref,
        );
      }

      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'customerWebhooks') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<CustomerWebhooksCollection>(
          state,
          transformIntoDocuments([result], transformCustomerWebhook),
          ref,
        );
      }

      return state;
    }

    case 'API_DELETE_SUCCESS': {
      if (action.payload.type === 'customerWebhooks') {
        const { originalDocument, ref } = action.payload;

        return removeDocumentById<CustomerWebhooksCollection>(
          ref,
          state,
          originalDocument.id,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
